import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar2 from '../../components/Navbar2';
import PageTitle from '../../components/pagetitle';
import ServiceSingleSection from '../../components/ServiceSingleSection';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import servicesData from '../../components/ServiceSingleSection/services.json'; // adjust if needed

const ServiceSinglePage = () => {
    const { slug } = useParams();
    const [service, setService] = useState(null);

    useEffect(() => {
        const found = servicesData.find(s => s.slug === slug);
        setService(found);
    }, [slug]);

    return (
        <Fragment>
            <Navbar2 />
            <PageTitle 
                pageTitle={service ? service.title : 'Loading...'} 
                pagesub={'Services'} 
            />
            <ServiceSingleSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default ServiceSinglePage;
